module.exports = __webpack_public_path__ + "img/remove.3284bc28.png";